module.exports = __webpack_public_path__ + "static/media/spx.940d6b4a.png";